@if(tierFeaturesModel != undefined){
<section class="tier-features-container" aria-labelledby="tier-title">
	<h2 id="tier-title" class="tier-features-title">{{ tierFeaturesModel.title }}</h2>
	<div class="tier-features-desc">
		<span>{{ tierFeaturesModel.text1 }}</span>
		<span>{{ tierFeaturesModel.text2 }}</span>
		<span>{{ tierFeaturesModel.text3 }}</span>
	</div>
	<div class="tier-features-list">
		@for (feature of tierFeaturesModel.tierFeatures; track feature.order) {

		<article class="tier-card" [class.highlighted]="feature.highLighted" itemscope itemtype="https://schema.org/Offer">

			<div class="tier-card-header">
				<h3 class="tier-card-title" itemprop="name">{{ feature.title }}</h3>
				@if (feature.highLighted) {
				<div class="tier-card-highlight">{{ feature.highLightLabel }}</div>
				} @else {
				<div class="tier-card-not-highlight"></div>
				}
				<div class="tier-card-subtitle" itemprop="description">{{ feature.subTitle }}</div>
			</div>
			<div class="tier-card-price">
				<span class="tier-price" itemprop="price">{{ feature.priceString }}</span>
				@if (feature.discountPercentage > 0) {
				<span class="tier-discount">-{{ feature.discountPercentage }}%</span>
				}
			</div>
			<div class="tier-card-description" itemprop="description">{{ feature.description }}</div>
			<ul class="tier-card-features" role="list">
				@for (item of feature.items; track item.order) {
				<li class="tier-feature-item" role="listitem">
					<span class="tier-feature-icon">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
							<path fill="#63E6BE"
								d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z" />
						</svg>
					</span>
					<span class="tier-feature-text">{{ item.text }}</span>
				</li>
				}
			</ul>
			<div class="hero-buttons">
				<button class="btn-primary"
					[routerLink]="['/', currentLang, 'cart', feature.productId]"
					[disabled]="!feature.isEnabled"
					[title]="feature.buttonText"
				>
					@if (!feature.isEnabled) {
						<span class="btn-icon-lock" aria-hidden="true">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" focusable="false">
								<path fill="#fff" d="M12 1a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V6a5 5 0 0 0-5-5m0 2a3 3 0 0 1 3 3v3H9V6a3 3 0 0 1 3-3m-6 8h12v8H6z" />
							</svg>
						</span>
					}
					<span class="btn-text">{{ feature.buttonText }}</span>
				</button>
			</div>
		</article>
		}
	</div>
<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": {{ '"' + (tierFeaturesModel.title) + '"' }},
  "itemListElement": [
    {{ tierFeaturesModel.tierFeatures.map(f => '{"@type":"Offer","position":'+(f.order)+',"name":"'+(f.title)+'"}') .join(', ') }}
  ]
}
</script>
</section>

}